import { Injectable } from "@angular/core";
import { HTTPService } from "./http.service";
import { UserAuthenticationServices } from "./user-authentication.services";
import { NavItem } from "../interfaces/nav-item";
import { Router } from "@angular/router";
import { InstanceConfiguration, InstanceGenericViewComponent } from "../forms/instance-generic-view/instance-generic-view.component";
import { AuthGuard } from "./auth.guard.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenLauncherComponent } from "../builder-screen-beta/screen-launcher/screen-launcher.component";
import { SystemViewNewComponent } from "../system-view/system-view-new/system-view-new.component";
import { SystemViewLayoutSelectorComponent } from "../system-view/system-view-layout-selector.component";

@Injectable({
    providedIn: HTTPService,
    useValue:false
})
export class MenuServices{

    mktpmenuResult = [];
    mktpmenuAcessResult = [];
    mktpmenuChildrenResult = [];
    childrenObj = [];
    firstLoad = false;
    /** NUMENU liberados para o usuario logado (MKTPMENUACESS.CANVIEW='S'). null = ADMIN, enxerga tudo. */
    menuAcessPermitido: Set<string> = null;
    navItems: NavItem[] = [];
    navItemsDefault: NavItem[] = [];
    promiseMenuArr = [];
    menuAcessItems = [];
    
    constructor(
      private http:HTTPService,
      private uas: UserAuthenticationServices,
      private router:Router,
      private translate:TranslateService){   
    }

    async getUsersMenuAcess(idMenu:String, query:any){ 
        await new Promise((resolve,reject)=>{ 
            let sqlMenu = `SELECT U.USERNAME, U.IDUSER, 
                (SELECT COUNT(1) FROM MKTPMENUACESS ACESS 
                WHERE ACESS.IDUSER = U.IDUSER AND ACESS.NUMENU = ${idMenu} 
                AND ACESS.CANVIEW = 'S') AS CANVIEW , 
                
                ${this.uas.user.profile !='ADMIN' ?
                `(SELECT COUNT(1)  CANVIEW FROM MKTPMENUACESS A 
                  WHERE A.CANVIEW = 'S' AND A.NUMENU = ${idMenu} 
                  AND A.IDUSER=${this.uas.user.iduser} ) CUCANVIEW ` : `1 CUCANVIEW`}
                FROM MKTPUSER U WHERE ISNULL(ACTIVE,'N')='S' `;
            
            if(query != null){

                if(isNaN(query)){ //nome
                    sqlMenu += ` AND U.USERNAME LIKE '%${query}%'`
                }else{ //codigo
                    sqlMenu += ` AND U.IDUSER = '${query}'`
                }
            }

            if ( this.uas.user.profile !='ADMIN' ){
              sqlMenu += ` AND U.IDUSER IN (
                                         SELECT IDUSER 
                                          FROM MKTPUSERCOMPANY 
                                          WHERE CODECOMPANY IN (SELECT CODECOMPANY
                                            FROM MKTPUSERCOMPANY WHERE IDUSER=${this.uas.user.iduser}) )`

              //sqlMenu += ` AND U.CODECONTRACT IN (${this.uas.getContracts()})`
              sqlMenu += ` AND U.IDUSER IN ( SELECT IDUSER FROM MKTPUSERCONTRACT WHERE CODECONTRACT IN (${this.uas.getContracts()}) )`
            }
            

            let queryBuscaMenus = { 
              "entityName":"Mktpmenu",
              "sql": sqlMenu
            }
              
            this.http.post(queryBuscaMenus,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
                
                this.mktpmenuAcessResult = con['SQL'];
                this.menuAcessItems = [];
              
                this.mktpmenuAcessResult.forEach(m=>{
                  
                  let menuUserAcess = {
                    name: m['USERNAME'],
                    id: m['IDUSER'],
                    view: m['CANVIEW'] > 0,
                    cuview: m['CUCANVIEW'] > 0
                  }

                  
                  
                  this.menuAcessItems.push(menuUserAcess);          
    
                  
                })     
              
                resolve(this.menuAcessItems);   
              
            })
                     
           
        });    
       
    }

    /**
     * Carrega os NUMENU que o usuario logado pode visualizar.
     *
     * A fonte de verdade da visibilidade do menu e a MKTPMENUACESS: e ela que a
     * tela de acessos (menu-view) grava e que a busca Ctrl+K consulta. O JSON de
     * ROLE nao e mais escrito por nenhuma tela, por isso nao serve mais para
     * montar o menu lateral (continua valendo para canEdit/canView de funcao).
     *
     * Retorna null para ADMIN, que enxerga a arvore inteira.
     */
    async getMenuAcess():Promise<Set<string>>{

        if ( this.uas.user.profile == 'ADMIN' ){
          this.menuAcessPermitido = null;
          return this.menuAcessPermitido;
        }

        return await new Promise((resolve,reject)=>{

            let queryBuscaAcesso = {
              "entityName":"Mktpmenu",
              "sql":`SELECT NUMENU FROM MKTPMENUACESS WHERE IDUSER = ${this.uas.user.iduser} AND CANVIEW = 'S'`
            }

            this.http.post(queryBuscaAcesso,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{

                let linhas:Object[] = con['SQL'] != null ? con['SQL'] : [];
                let permitidos = new Set<string>();

                linhas.forEach(linha=>{
                  permitidos.add(String(linha['NUMENU']));
                });

                this.menuAcessPermitido = permitidos;
                resolve(permitidos);

            },error=>{
                // sem resposta do servidor nao da para afirmar que o usuario tem acesso;
                // conjunto vazio esconde o menu em vez de liberar o sistema inteiro
                console.error('Erro ao carregar MKTPMENUACESS:', error);
                this.menuAcessPermitido = new Set<string>();
                resolve(this.menuAcessPermitido);
            });

        });

    }

    async getMenus(){

        return await new Promise((resolve,reject)=>{ 
    
            let queryBuscaPais = { //Atualmente só temos a coluna para ordenar os filhos (mktpmenulig), os pais estão sendo colocados na ordem do insert, depois podemos ter uma coluna de ordem para alinhar os pais.
              "entityName":"Mktpmenu",
              //"sql":`SELECT M.NUMENU, M.IDMENU, M.DESCRIPTION, M.PROPERTIES, (SELECT COUNT(1) FROM MKTPMENULIG LIG WHERE NUMENU = M.NUMENU) AS QTDCHILD, M.LANGUAGE FROM Mktpmenu M WHERE M.ENABLE = 'S' AND M.TYPE = 'R' `
              "sql":`SELECT M.NUMENU, M.IDMENU, M.DESCRIPTION, M.PROPERTIES, (SELECT COUNT(1) FROM MKTPMENULIG LIG WHERE NUMENU = M.NUMENU) AS QTDCHILD FROM Mktpmenu M WHERE M.ENABLE = 'S' AND M.TYPE = 'R' `
            }
              
            this.http.post(queryBuscaPais,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
                this.mktpmenuResult = con['SQL'];
                this.navItems = [];
                this.mktpmenuResult.forEach(m=>{
                  
                  let nuMenu = m['NUMENU'];
                
                  let navItem = this.buildNavItemObj(m,0);
    
                  let qtdChild = m['QTDCHILD'];
    
                  if(qtdChild > 0){
                    this.promiseMenuArr.push(this.getChildrenNav(nuMenu, navItem));   //busca os filhos do menu root.            
                  }
                  
                  this.navItems.push(navItem as NavItem);          
    
                  
                })     
              
                resolve(this.navItems);   
              
            })
                     
           
        });    
       
    }

    buildNavItemObj(dbObj, level){

        let properties = dbObj['PROPERTIES'].replace('\n', ``);
                        
        let jsonProperties:JSON = JSON.parse(properties);
        
        let navItem = {
          id:dbObj['IDMENU'],
          nuMenu:dbObj['NUMENU'],
          displayName:dbObj['DESCRIPTION'],
          language:dbObj['LANGUAGE'],
          level: level
        }

        if ( dbObj['LANGUAGE']!=null){
          let language = dbObj['LANGUAGE'];
          let languageList:Object[] = JSON.parse(language);
          
          for ( var lang of languageList){
            let ob = { 
              ['menu.'+dbObj['NUMENU']]: lang['text']
            }
            this.translate.setTranslation(lang['language'], ob,true);
          }
        }
    
        Object.keys(jsonProperties).forEach(valueKey=>{
          try{
            if ( valueKey != 'displayName' && valueKey != 'id' ){
              navItem[valueKey] = jsonProperties[valueKey];
            }
            if ( valueKey == 'instanceDynamicView'){
              if ( jsonProperties['instanceDynamicView']){
                this.loadInstanceDynamicViewRoute(dbObj['IDMENU'],jsonProperties);
              }
            }
            // Suporte para Screen Launchers
            if ( valueKey == 'isScreenLauncher'){
              if ( jsonProperties['isScreenLauncher']){
                this.loadScreenLauncherRoute(dbObj['IDMENU'],jsonProperties);
              }
            }
          }catch(Exception){
          }
        })
    
        return navItem;
    }
    
    loadInstanceDynamicViewRoute(idMenu, jsonProperties: JSON) {
    
      if ( jsonProperties['entities']){
          let entities = jsonProperties['entities'] as InstanceConfiguration
          let route = {
              path: idMenu,
              component: InstanceGenericViewComponent,
              data: {"entities":entities, "idMenu": idMenu, "title":jsonProperties['title']},
              canActivate: [AuthGuard],
          }
          this.router.config.find(d=>d.component==SystemViewNewComponent || d.component==SystemViewLayoutSelectorComponent).children.push(route);
      }
    }

    /**
     * Carrega rota dinâmica para Screen Launcher
     */
    loadScreenLauncherRoute(idMenu: string, jsonProperties: any) {      
      
      if ( jsonProperties['templateId']){
          const templateId = jsonProperties['templateId'];          
          
          const route = {
              path: idMenu,
              component: ScreenLauncherComponent, // ✅ Componente REAL agora
              data: { 
                templateId: templateId, 
                idMenu: idMenu, 
                title: jsonProperties['displayName'] || jsonProperties['title']
              },
              canActivate: [AuthGuard],
          };
          
                    
          // Adiciona a rota dinamicamente
          const systemViewRoute = this.router.config.find(d=>d.component==SystemViewNewComponent || d.component==SystemViewLayoutSelectorComponent);
          
          
          if (systemViewRoute && systemViewRoute.children) {
            // Verifica se a rota já não existe
            const routeExists = systemViewRoute.children.some(r => r.path === idMenu);0
            if (!routeExists) {
              systemViewRoute.children.push(route);              
            } 
          } else {
            console.error('❌ SystemViewRoute não encontrada ou não possui children');
          }
      } else {
        console.error('❌ templateId não encontrado em jsonProperties');
      }
    }
  
    async getChildrenNav(idPai, navItem){
    
        return new Promise((resolve,reject)=>{
    
            let buscaFilhos = ` SELECT  * FROM ( `;
            buscaFilhos += ` SELECT  M.NUMENU, M.IDMENU, M.DESCRIPTION, M.PROPERTIES, `;
            buscaFilhos += `(SELECT LIG2.SEQUENCE FROM MKTPMENULIG LIG2 WHERE LIG2.NUMENU = ${idPai} AND LIG2.NUMENUF = M.NUMENU) AS ORDEM, `;
            buscaFilhos += `(SELECT COUNT(1) FROM MKTPMENULIG LIG3 WHERE LIG3.NUMENU = M.NUMENU) AS QTDCHILD`
            buscaFilhos += ` FROM Mktpmenu M  WHERE M.NUMENU IN (SELECT NUMENUF FROM MKTPMENULIG LIG WHERE LIG.NUMENU = ${idPai}) ) X `;
            buscaFilhos += ` ORDER BY X.ORDEM`;
                                  
    
            let queryBuscaFilhos = {
              "entityName":"Mktpmenulig",
              "sql":buscaFilhos
            }
            
            this.http.post(queryBuscaFilhos,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{

                let filhosResult = con['SQL'] != null ? con['SQL'] : [];

                // listas locais: a recursao dos netos e assincrona e nao pode
                // disputar os campos de instancia com os outros ramos da arvore
                let filhosDoNivel:NavItem[] = [];
                let promessasNetos:Promise<any>[] = [];

                filhosResult.forEach(m=>{

                  let idMenu = m['NUMENU'];
                  let qtdChild = m['QTDCHILD'];

                  let navItemObj = this.buildNavItemObj(m, navItem.level + 1);
                  filhosDoNivel.push(navItemObj as NavItem);

                  if(qtdChild > 0){ //evita chamadas desnecessárias para saber se tem filho
                    promessasNetos.push(this.getChildrenNav(idMenu, navItemObj ));
                  }


              });

              this.mktpmenuChildrenResult = filhosResult;
              this.childrenObj = filhosDoNivel;

              if(filhosDoNivel.length > 0){
                navItem.children = filhosDoNivel;
              }

              // so resolve depois que todos os niveis abaixo chegarem, senao o
              // loadPermissions roda antes dos netos existirem na arvore e eles
              // ficam sem a marcacao de visibilidade
              Promise.all(promessasNetos).then(()=>resolve(true));

            });
        });
    
    }
 
    
    getNewMenu(){
      
      return new Promise((resolve,reject)=>{
        let queryMenu = {
          "entityName":"Mktpmenu",
          "sql":"SELECT * FROM MKTPMENU WHERE ENABLE='S'"
        }
        this.http.post(queryMenu,'JsonBrokerServices/findnative',false,true,true).subscribe(menu=>{
          let menuList = menu['SQL'] as Object[];
          
          let queryLig = {
            "entityName":"Mktpmenulig",
            "sql":"SELECT * FROM MKTPMENULIG WHERE ENABLE='S'"
          }
          
          this.http.post(queryLig,'JsonBrokerServices/findnative',false,true,true).subscribe(lig=>{
            let ligacao = lig['SQL'] as Object[];
              
            let rootMenu:NavItem[] = [
                {
                  children:[],
                  displayName:'Menu',
                  expanded:false,
                  disabled:false,
                  hidden:false,
                  id:"menu",
                  nuMenu:"0",
                  visible:true,
                  iconName:"home",
                  showButton: false,
                  type:'R',
                  entities:[],
                  instanceDynamicView: false,
                  isDynamicForm: false,
                  level:0
                }
              ]
        
              menuList.filter(x=>x['TYPE']=='R').forEach(d=>{
                  this.createNavItem(d,1,rootMenu[0],menuList,ligacao,null,0);
              });
              resolve(rootMenu);
          });

        });  
      })
      

    }
    createNavItem(item:Object,index:number, listMenu:NavItem, menu:Object[], menuLig:Object[],sequence:number, level:number = 0):NavItem{
      
      if (item == null){
        return;
      }
      let properties:any = JSON.parse(item['PROPERTIES']);
     
      let navItem:NavItem = {
        displayName: properties.displayName== null ? item['DESCRIPTION']:properties.displayName,
        expanded:false,
        hidden: false,
        id:properties.id,
        nuMenu:item['NUMENU'],
        visible: true,
        disabled:false,
        children:[],
        iconName:properties.iconName,
        svgIconName:properties.svgIconName,
        showButton:false,
        type:item['TYPE'],
        instanceDynamicView: properties.instanceDynamicView,
        isDynamicForm: properties.isDynamicForm,
        sequence: sequence != null ? sequence : null,
        level: level
      };

      if (properties != null){
        if ( properties['entities']!=null){
          navItem.entities = JSON.parse(JSON.stringify(properties['entities']));
        }else{
          navItem.entities = [];
        }
      }
      
      if ( this.hasChildren(item['NUMENU'],menuLig)){
        let childrens:Object[] = this.getChildren(item['NUMENU'],menuLig);
        childrens.forEach(filho=>{
            let f = filho['NUMENUF'];
            let sequence = filho['SEQUENCE'];
            let fMenu = menu.find(d=>d['NUMENU'] == f);
            this.createNavItem(fMenu, index +1,navItem,menu,menuLig,sequence,level++); 
            
        });  
        listMenu.children.push(navItem);
      }else{
        listMenu.children.push(navItem);
      }
      
      return navItem;
    }

    hasChildren(nuMenu:string,menulig:Object[]){
      return menulig.findIndex(d=>d['NUMENU']==nuMenu)>-1;
    }

    getChildren(nuMenu:string,menulig:Object[]){
      return menulig.filter(d=>d['NUMENU']==nuMenu);
    }
 
        

}

